import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './auth/AuthContext'
import { api } from './services/api'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Upload from './pages/Upload'
import Snapshots from './pages/Snapshots'
import Portfolio from './pages/Portfolio'
import Accounts from './pages/Accounts'
import Subsectors from './pages/Subsectors'
import FxRates from './pages/FxRates'
import Options from './pages/Options'
import BenchmarkRates from './pages/BenchmarkRates'
import BuySell from './pages/BuySell'
import Login from './pages/Login'
import config from './config'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, getToken } = useAuth()

  // Set up API token getter
  useEffect(() => {
    api.setTokenGetter(getToken)
  }, [getToken])

  // Skip auth check if auth is disabled
  if (!config.features.authEnabled) {
    return <>{children}</>
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  console.log('App rendering, authEnabled:', config.features.authEnabled)

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/callback" element={<Login />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="upload" element={<Upload />} />
        <Route path="snapshots" element={<Snapshots />} />
        <Route path="portfolio/:uploadId" element={<Portfolio />} />
        <Route path="buysell/:underlying" element={<BuySell />} />
        <Route path="accounts" element={<Accounts />} />
        <Route path="subsectors" element={<Subsectors />} />
        <Route path="fx-rates" element={<FxRates />} />
        <Route path="options" element={<Options />} />
        <Route path="benchmark-rates" element={<BenchmarkRates />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
